// Open-now from the owner's hours lines ("Monday: 07:00 – 15:00", "Sunday: Closed"; also
// "7:00 AM – 3:00 PM"). Returns null when today's line is missing or unreadable, so callers hide
// the pill rather than guess. ponytail: uses the viewer's clock, so it assumes the viewer is in
// the shop's timezone; store the shop's timezone if people browse other cities in bulk.
const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const toMinutes = (t) => {
  const m = /^(\d{1,2}):(\d{2})\s*(AM|PM)?$/i.exec(t.trim());
  if (!m) return null;
  let h = Number(m[1]) % (m[3] ? 12 : 24);
  if (m[3]?.toUpperCase() === "PM") h += 12;
  return h * 60 + Number(m[2]);
};

const parseDay = (lines, day) => {
  const line = lines.find((l) => l.toLowerCase().startsWith(day.toLowerCase() + ":"));
  if (!line) return null;
  const rest = line.slice(day.length + 1).trim();
  if (/^closed$/i.test(rest)) return "closed";
  const [open, close] = rest.split(/\s*[–-]\s*/).map(toMinutes);
  return open == null || close == null ? null : { open, close };
};

export function isOpenNow(lines, now = new Date()) {
  if (!Array.isArray(lines)) return null;
  const mins = now.getHours() * 60 + now.getMinutes();
  const today = parseDay(lines, DAYS[now.getDay()]);
  // Yesterday's hours can run past midnight into today ("18:00 – 02:00").
  const yesterday = parseDay(lines, DAYS[(now.getDay() + 6) % 7]);
  if (yesterday && yesterday !== "closed" && yesterday.close < yesterday.open && mins < yesterday.close) return true;
  if (today == null) return null;
  if (today === "closed") return false;
  return today.close > today.open
    ? mins >= today.open && mins < today.close
    : mins >= today.open;
}
